export default {"src":"/_next/static/media/pristin.18bdb35f.svg","height":36,"width":58,"blurWidth":0,"blurHeight":0};